import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { ViewProperties } from "../../../utils/ViewProperties";
import { GameLang } from "../lang/GameLang";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
export class GameScatterPickBackgroundProperties extends ViewProperties {
    constructor() {
        super(...arguments);
        this.mouseBlockerProperties = new MouseBlockerProperties(0x2B1B40, 0.8, false);
        this.backgroundSpineProperties = new SpineProperties(GameStyle.COCONUT_BACKGROUND, GameStyle.MODULE, null, new Point(0.5, 0.5)); // TODO: scale per-orienation when not so epic
        this.titleSpineProperties = new SpineProperties(GameStyle.COCONUT_TITLE, GameStyle.MODULE);
        this.instructionsProperties = new TextFieldProperties(GameFontStyle.SCATTER_PICK_INSTRUCTIONS, null, GameLang.SCATTER_GAME2, null, null, new Point(800, 200));
        this.minSpeed = 1;
        this.maxSpeed = 5;
        this.fadeInDuration = 2;
        this.fadeOutDuration = 3;
    }
}
//# sourceMappingURL=GameScatterPickBackgroundProperties.js.map